import { default as i18n, default as i18next } from 'i18next';
import { initReactI18next } from 'react-i18next';

let translationEN;
let translationDE;
let translationES;
let translationIT;
let translationJA;
let translationFR;
let translationPL;
if (process.env.NODE_ENV === 'test') {
  translationEN = require('../../common/localizations/en/translation.json');
  translationDE = require('../../common/localizations/de/translation.json');
  translationES = require('../../common/localizations/es/translation.json');
  translationIT = require('../../common/localizations/it/translation.json');
  translationJA = require('../../common/localizations/ja/translation.json');
  translationFR = require('../../common/localizations/fr/translation.json');
  translationPL = require('../../common/localizations/pl/translation.json');
} else {
  translationEN = require('./localizations/en/translation.json');
  translationDE = require('./localizations/de/translation.json');
  translationES = require('./localizations/es/translation.json');
  translationIT = require('./localizations/it/translation.json');
  translationJA = require('./localizations/ja/translation.json');
  translationFR = require('./localizations/fr/translation.json');
  translationPL = require('./localizations/pl/translation.json');
}

export const availableApiLanguages = [
  { languageCode: 'en', description: 'English' },
  { languageCode: 'de', description: 'Deutsch' },
  { languageCode: 'es', description: 'Español' },
  { languageCode: 'it', description: 'Italiano' },
  { languageCode: 'ja', description: '日本語' },
  { languageCode: 'fr', description: 'Français' },
  { languageCode: 'pl', description: 'Polski' },
];

const resources = {
  en: {
    translation: translationEN,
  },
  de: {
    translation: translationDE,
  },
  es: {
    translation: translationES,
  },
  it: {
    translation: translationIT,
  },
  ja: {
    translation: translationJA,
  },
  fr: {
    translation: translationFR,
  },
  pl: {
    translation: translationPL,
  },
};

export const STORED_LANG_KEY = 'sphere-stored-lang';
const getStoredOrDefaultLanguage = () => {
  const storedLanguageCode = localStorage.getItem(STORED_LANG_KEY);
  return (
    availableApiLanguages.find((l) => l.languageCode === storedLanguageCode) ??
    availableApiLanguages[0]
  );
};

export const getCurrentLanguage = () => {
  const language = availableApiLanguages.find((lang) => lang.languageCode === i18next.language);
  return language ?? getStoredOrDefaultLanguage();
};

export const isKeyInTranslation = (key: string) => {
  return key in resources.en.translation;
};

i18n.use(initReactI18next).init({
  resources: resources,
  lng: getStoredOrDefaultLanguage().languageCode,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
